<template>
  <div class="form-container userform-container">
    <h1>利用者の編集</h1>
    <form @submit.prevent="registerUser">
      <table class="info-table" :class="{ 'disabled-table': isDisabled }">
        <tbody>
          <tr>
            <td><label class="required-label">都道府県</label></td>
            <td><label>:</label></td>
            <td>
              <select v-model="region_id" :class="{ 'input-error': errors.region }" :disabled="disabledStates.systemAdmin">
                <option value="" disabled>都道府県を選択してください</option>
                <option 
                  v-for="region in regions" 
                  :key="region.region_id" 
                  :value="region.region_id">
                  {{ region.region_id + ' ' + region.region_nm }}
                </option>
              </select>
              <span v-if="errors.region" class="error-message">{{ errors.region }}</span>
            </td>
          </tr>

		  <!-- R.K -->
          <tr>
            <td><label class="required-label">行政機関</label></td>
            <td><label>:</label></td>
            <td>
              <select v-model="group_id" :disabled="limited">
                <option value="" disabled>行政機関を選択してください</option>
                <option 
                  v-for="group in groups" 
                  :key="group.gyouseiId" 
                  :value="group.gyouseiId">
                  {{ group.gyouseiId + ' ' + group.gyouseiName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">利用者</label></td>
            <td><label>:</label></td>
            <td>
              <select v-model="user_id" :disabled="limitedu">
                <option value="" disabled>利用者を選択してください</option>
                <option 
                  v-for="user in users" 
                  :key="user.id" 
                  :value="user.id">
                  {{ user.id + ' ' + user.nameKanji }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">利用者ID</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="editUser.userId" type="text"  disabled/>
              <span v-if="errors.userId" class="error-message">{{ errors.userId }}</span>
              <button v-else @click="openModal" class="first" :class="{ disabled: disabledButton.search }" :disabled="limitedu">
                利用者検索
              </button>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">利用者氏名（漢字）</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="editUser.fullNameKanji" type="text" :class="{ 'input-error': errors.fullNameKanji }" maxlength="50" @blur="validateOnBlur('fullNameKanji', editUser.fullNameKanji)"/>
              <span v-if="errors.fullNameKanji" class="error-message">{{ errors.fullNameKanji }}</span>
            </td>
          </tr>
          <tr>
            <td><label>利用者氏名（カナ）</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="editUser.fullNameKana" type="text" :class="{ 'input-error': errors.fullNameKana }" maxlength="50" @blur="validateOnBlur('fullNameKana', editUser.fullNameKana)"/>
              <span v-if="errors.fullNameKana" class="error-message">{{ errors.fullNameKana }}</span>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">利用者区分</label></td>
            <td><label>:</label></td>
            <td>
              <div >
                <div :class="{ 'radio-group-error': errors.userType }">
                  <label><input type="radio" value="システム管理者" v-model="editUser.userType" :disabled="disabledStates.systemAdmin" @change="validateOnBlur('userType', editUser.userType)"/> システム管理者</label>
                  <label><input type="radio" value="行政機関" v-model="editUser.userType" :disabled="disabledStates.admin" @change="handleAdminSelectionChange" /> 行政機関</label>
                  <label><input type="radio" value="その他" v-model="editUser.userType" :disabled="disabledStates.other" @change="handleOtherSelectionChange" @input="validateOnBlur('userType', editUser.userType)"/> その他</label>
                </div>
                <span v-if="errors.userType" class="error-message">{{ errors.userType }}</span>
              </div>
              <div v-if="editUser.userType === '行政機関'">
                <label><input type="radio" value="行政機関管理者" v-model="editUser.adminType" :disabled="disabledStates.member"/> 行政機関管理者</label>
                <label><input type="radio" value="行政機関メンバー" v-model="editUser.adminType" :disabled="disabledStates.member"/> 行政機関メンバー</label>
              </div>
              <div v-if="editUser.userType === 'その他'">
                <label><input type="radio" value="捕獲者" v-model="editUser.otherType" :disabled="disabledStates.admin"/> 捕獲者</label>
                <label><input type="radio" value="見える化管理者" v-model="editUser.otherType" :disabled="disabledStates.member"/> 見える化管理者</label>
                <label><input type="radio" value="見える化メンバー" v-model="editUser.otherType" :disabled="disabledStates.member"/> 見える化メンバー</label>
              </div>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">部署名</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="editUser.department" type="text" :class="{ 'input-error': errors.department }"  maxlength="20" @blur="validateOnBlur('department', editUser.department)"/>
              <span v-if="errors.department" class="error-message">{{ errors.department }}</span>
            </td>
          </tr>
		  <!-- R.K -->

          <tr>
            <td><label>パスワード</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="editUser.password" type="password" :class="{ 'input-error': errors.password }" maxlength="40" @blur="validateOnBlur('password', editUser.password)"/>
              <span v-if="errors.password" class="error-message">{{ errors.password }}</span>
			  <span class="abc">
			    <label>パスワードは空打ちした場合は変りません</label>
			  </span>
            </td>
          </tr>
          <tr>
            <td><label>パスワード(確認用)</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="editUser.passwordConfirm" type="password" :class="{ 'input-error': errors.passwordConfirm }" maxlength="40" @blur="validateOnBlur('password', editUser.passwordConfirm)"/>
              <span v-if="errors.passwordConfirm" class="error-message">{{ errors.passwordConfirm }}</span>
			  <span class="abc">
			    <label>入力した場合は新しい値で上書きされます</label>
			  </span>
            </td>
          </tr>
          <tr>
            <td><label>備考</label></td>
            <td><label>:</label></td>
            <td>
              <textarea v-model="editUser.notes" :class="{ 'input-error': errors.notes }"  maxlength="200" @blur="validateOnBlur('notes', editUser.notes)"></textarea>
              <span v-if="errors.notes" class="error-message">{{ errors.notes }}</span>
            </td>
          </tr>

          <tr>
            <td><label>所属行政機関の選択</label></td>
            <td><label>:</label></td>
            <td>
              <div class="affiliated-admin-container">
                <table>
                  <tbody>
                    <tr>
                      <td>

                        <select 
                          v-model="org_sel" 
                          multiple 
                          size="7" 
                          style="width: 200px; height: 160px;" 
                          :disabled="!editUser.directAdminOrg || disabledStates.member"
                        >
                          <option 
                            v-for="(org, index) in org_left" 
                            :key="org.gyouseiId || index" 
                            :value="org.gyouseiId"
                          >
                            {{ org.gyouseiName }}
                          </option>
                        </select>

                      </td>
                      <td align="center" class="button-column-container">
                        <button 
                          type="button" 
                          @click="addAllAffiliatedOrgs" 
                          :disabled="!editUser.directAdminOrg || disabledStates.member"
                        >全登録</button>
                        <button 
                          type="button" 
                          @click="addOneAffiliatedOrg" 
                          :disabled="!editUser.directAdminOrg || disabledStates.member"
                        >＞＞</button>
                        <button 
                          type="button" 
                          @click="removeOneAffiliatedOrg" 
                          :disabled="!editUser.directAdminOrg || disabledStates.member"
                        >＜＜</button>
                        <button 
                          type="button" 
                          @click="removeAllAffiliatedOrgs" 
                          :disabled="!editUser.directAdminOrg || disabledStates.member"
                        >全解除</button>
                      </td>
                      <td>
                        <select 
                          v-model="org_sel" 
                          multiple 
                          size="7" 
                          style="width: 200px; height: 160px;" 
                          :class="{ 'input-error': errors.org_right }" 
                          @change="validateOnBlur('org_right', editUser.org_right)" 
                          :disabled="!editUser.directAdminOrg || disabledStates.member"
                        >
                          <option 
                            v-for="org in org_right" 
                            :key="org.gyuseiId" 
                            :value="org.gyouseiId"
                          >
                            {{ org.gyouseiName }}
                          </option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <span 
                v-if="errors.org_right" 
                class="error-message" 
                style="text-align: right;"
              >{{ errors.org_right }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
    <div class="button-group">
      <!-- 削除済みデータの時は「復元」ボタンを表示 -->
      <button v-if="isDisabled" class="alert" @click="restoreEditUser">復元</button>

      <!-- 通常時は「更新」と「削除」ボタンを表示 -->
      <template v-else>
        <button type="submit" class="second" :disabled="btnoff" @click="deleteeditUser">削除</button>
        <button type="submit" class="alert" :disabled="btnoff"  @click="updateeditUser">更新</button>
      </template>
    </div>
    <!-- 検索モーダル -->
    <SearchModal 
      caller="user"
      :isVisible="isModalVisible"
      :displayColumns="[
        { key: 'id', label: '利用者ID' },
        { key: 'nameKanji', label: '利用者氏名（漢字）' },
        { key: 'nameKana', label: '利用者氏名（カナ）' }
      ]"
      :title="modalTitle"
      :searchData="searchData" 
      @close="closeModal" 
      @select="handleSelect" 
    />
  </div>
</template>

<script>
import "@/assets/styles/User.css";

import userValidationMixin from '@/mixins.js';
import SearchModal from '@/vue/SearchModal.vue';
import axios from "axios";
axios.defaults.timeout = process.env.VUE_TIMEOUT||5000;

export default {
  mixins: [userValidationMixin],
  name: 'UserEdit',
  components: {
    SearchModal,
  },
  data() {
    return {
	  btnoff: true,
	  limited: false,
	  limitedu: false,
	  section: '',
	  group_id: '',
	  groups: [],
	  region_id: '',
	  user_id: '',
	  users: [],

      isDisabled: false,
      initFlg: true,
      regions: [],
      org_sel: [],
	  org_right: [],
      org_left: [],
      userTypeMapping: {
        "システム管理者": "0000",
        "行政機関": "01",
        "その他": "02",
      },
      adminTypeMapping: {
        "行政機関管理者": "00",
        "行政機関メンバー": "01",
      },
      otherTypeMapping: {
        "捕獲者": "01",
        "見える化管理者": "10",
        "見える化メンバー": "11",
      },
      editUser: {
        deleteFlg: '',
        region: '',
        userId: '',
        password: '',
        passwordConfirm: '',
        userType: '',
        adminType: [],
        otherType: [],
        email: '',
        fullNameKanji: '',
        fullNameKana: '',
        zip: '',
        address1: '',
        address2: '',
        birthday: { type: '', year: '', month: '', day: '' },
        sex: '',
        homePhone: '',
        mobilePhone: '',
        department: '',
        notes: '',
        directAdminOrg: '',
        userType: "",
        adminType: "",
        otherType: "",
      },
      disabledStates: {
        systemAdmin: false,
        admin: false,
        mieruAdmin: false,
        other: false,
        member: false,
      },
      disabledButton: {
        search: true,
        update: true,
        delete: true,
      },
      disabledOrganization: {
        affiliation: true,
      },
      originaleditUser: null,
      isErrorMode: false, // エラーモードフラグ
      errors: {}, // エラーメッセージを格納
      isModalVisible: false,
      searchData: {
        searchTerm: '',
        category: 'all',
      },
      modalTitle: '利用者検索',  // モーダルのタイトル
      //selectedResult: null,  // 選択された検索結果
    };
  },
  mounted() {
   	this.updateDisabledStates();
   	this.updateButtonDisabledStates();
   	this.deleteButtonDisabledStates();
   	this.searchButtonDisabledStates();
   	this.organizationDisabledStates();
    this.getRegionDetails();
    this.section = localStorage.getItem("section");
    if (this.section != '0000') {
		this.limited = true;
		this.region_id = localStorage.getItem("regionId");
	}
  },
  watch: {
	// 2026/04/01 added by RFJ R.Komatsu
	region_id: async function() {
	  if (!this.region_id) return;
      this.editUser.region = this.region_id;

      const token = localStorage.getItem("jwtToken");
      const requestData = { regionId: this.region_id };
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/addminAgencyRegister/getRegionList`,
          requestData,
          {
            headers: {           
              Authorization: `Bearer ${token}`, // JWTトークンを送信
            },
          }
        );
        this.groups = response.data.data;
		this.group_id = '';
		this.org_left = this.groups;
		this.selectedAdminOrgs = this.groups;
		this.users = [];
		this.user_id = '';
		if (this.section != "0000") {
    		this.group_id = localStorage.getItem("directAdminAgency");
		}
      } catch (error) {
		this.timeout();
      }
	  this.btnoff = true;
	},
	group_id: async function() {
	  if (!this.group_id) return;
      this.editUser.directAdminOrg = this.group_id;

      try {
      	const token = localStorage.getItem("jwtToken");
		// 意味不明だが・・・必須
      	const user_id = localStorage.getItem("user_id");
        const para = { id: user_id };
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/userRegister/getList`,
          para,
          { headers: { Authorization: `Bearer ${token}` } }
        );

	  	const users = response.data.data;
      	this.users = users.filter((org) =>
			 org.directAdminAgency == this.group_id);
		// このセキュリティはおかしいけど踏襲する
		if (this.section=="0000") {
	  		this.user_id = '';
		} else if (this.section.endsWith("00")) {
	  		this.user_id = '';
      		this.users = this.users.filter((org) =>
				 org.section!="0000");
		} else if (this.section=="0210") {
	  		this.user_id = '';
      		this.users = this.users.filter((org) =>
				 org.section.startsWith("021"));
		} else {
    		this.user_id = localStorage.getItem("userId");
			this.limitedu = true;
	  	}
	  	this.btnoff = true;
      } catch (error) {
		this.timeout();
      }
      this.org_left = this.groups;
	},
	user_id: async function() {
	  if (!this.user_id) return;
      this.editUser.userId = this.user_id;
      try {
      	const token = localStorage.getItem("jwtToken");
        const para = { id: this.user_id };
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/userRegister/getDetail`,
          para,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      	this.getUserDetails(response.data.data);

      } catch (error) {
		if (error.status==404) {
        	alert("登録されていません");
      		this.resetForm();          
	  		this.btnoff = true;
			return;
		}
		this.timeout();
      }
    },
  },
  methods: {
	timeout() {
        alert("タイムアウトです、ログインしなおしてください");
        this.$router.push({ name: 'Login' });
	},
    updateUserType() {
      // チェックボックスを初期化
      this.editUser.adminType = [];
    },
    updateAdminType() {
      this.editUser.otherType = [];
    },
    updateOtherType() {
      this.editUser.adminType = [];
    },
    // 選択した1つの行政機関を右側に移動
    addOneAffiliatedOrg() {
      this.org_sel.forEach((orgId) => {
        const org = this.org_left.find((o) => o.gyouseiId === orgId);
        if (org && !this.org_right.includes(org)) {
          this.org_right.push(org);
          // 右に移動したので、左リストから削除
          this.org_left = this.org_left.filter(
			(o) => o.gyouseiId !== orgId);
        }
      });
      this.org_sel = [];
    },
    // 選択した1つの行政機関を左側に戻す
    removeOneAffiliatedOrg() {
      // 選択された名前（name）を基に処理
      this.org_sel.forEach((selectedId) => {
        // 右側リストから該当の項目を検索（id で一致）
        const orgIndex = this.org_right.findIndex(
          (org) => org.gyouseiId === selectedId
        );

        if (orgIndex !== -1) {
          // 該当項目を取得して右リストから削除
          const [removedOrg] = this.org_right.splice(orgIndex, 1);

          // 左側リストに追加（重複チェック付き）
          if (!this.org_left.some((org) => org.gyouseiId === removedOrg.id)) {
            this.org_left = [...this.org_left, removedOrg];
          }
        }
      });

      // 選択状態をリセット
      this.org_sel = [];
    },
    addAllAffiliatedOrgs() {
      // 全て移動
      this.org_right = [...this.org_right, ...this.org_left];
      this.org_left = [];
    },
    removeAllAffiliatedOrgs() {
      // 右側の選択肢を左側に移動
      this.org_left = [...this.org_left, ...this.org_right];

      // 重複を排除（IDで一意なリストを作成）
      this.org_left = this.org_left.filter((org, index, self) =>
        index === self.findIndex((o) => o.gyouseiId === org.gyouseiId)
      );

      // 右側の選択肢をクリア
      this.org_right = [];
    },
    // 行政機関選択専用のチェンジメソッド
    handleAdminSelectionChange() {
      // 1. 行政機関関連の状態を更新
      this.updateAdminType();

      // 2. バリデーションを実行
      this.validateOnChange('userType', this.editUser.userType);
    },
    // その他選択専用のチェンジメソッド
    handleOtherSelectionChange() {
      // 1. その他関連の状態を更新
      this.updateOtherType();

      // 2. バリデーションを実行
      this.validateOnChange('userType', this.editUser.userType);
    },
    // ラジオボタン選択時の再バリデーションチェック
    validateOnChange(field, value) {
      const result = this.validateForm([
        {
          field,
          value,
          isRequired: true,
        },
      ]);
      this.errors[field] = result[field] || ''; // エラーがなければ解除
    },
    // フォーカスアウト時の再バリデーションチェック
    validateOnBlur(field, value) {

      if (!this.isErrorMode) return; // エラーモードがオフの場合は処理しない

      const result = this.validateForm([{ field, value, isRequired: true }]);
      this.errors[field] = result[field] || ''; // エラーがなければエラーを解除
    },
    // 所属行政機関の選択変更時のバリデーション
    validateSelectedAffiliatedOrgs(field) {
      // 配列チェックの場合`org_right` を使用
      const result = this.validateForm([
        {
          field,
          value: this.org_right, // 正確な配列をバリデーション
          isRequired: true,
        },
      ]);

      // エラーの更新
      this.errors[field] = result[field] || ''; // エラーがなければ解除
    },
    updateDisabledStates() {
      // セクションに基づいて無効状態を設定
      const section = localStorage.getItem("section");
      if (section === '0000') {
        this.disabledStates = {
          systemAdmin: false,
          admin: false,
          mieruAdmin: false,
          other: false,
          member: false,
        };
      } else if (section === '0100') {
        this.disabledStates = {
          systemAdmin: true,
          admin: false,
          mieruAdmin: true,
          other: false,
          member: false,
        };
      } else if (section === '0210') {
        this.disabledStates = {
          systemAdmin: true,
          admin: true,
          mieruAdmin: false,
          other: false,
          member: false,
        };
      } else {
        // デフォルト設定
        this.disabledStates = {
          systemAdmin: true,
          admin: true,
          mieruAdmin: true,
          other: true,
          member: true,
        };
      }
    },
    updateButtonDisabledStates() {
      // セクションに基づいて無効状態を設定
      const userId = localStorage.getItem("userId");
      const section = localStorage.getItem("section");
      // 利用者区分取得
      let userType = this.userTypeMapping[this.editUser.userType];
      if (this.editUser.userType === "行政機関") {
        userType = userType.concat(this.adminTypeMapping[this.editUser.adminType]);
      } else if (this.editUser.userType === "その他") {
        userType = userType.concat(this.otherTypeMapping[this.editUser.otherType]);
      }
      // 初期化
      this.disabledButton.update = true;

      if (userId === this.editUser.userId) {
        // 本人のデータは変更可能
        this.disabledButton.update = false;
      } else {
        // 本人以外のデータは権限に応じて変更可否
        if (section === '0000') {
          // システム管理者
          // システム管理者は本人以外のデータはすべて変更可能
          this.disabledButton.update = false;
        } else if (section === '0100') {
          // 行政機関・行政機関管理者
          if (userType != '0000') {
            // システム管理者以外のデータは変更可能
            this.disabledButton.update = false;
          }
        } else if (section === '0210') {
          // その他・見える化管理者
          if (userType === '0210' || userType === '0211') {
            // 見える化管理者、見える化メンバーのデータは変更可能
            this.disabledButton.update = false;
          }
        }
      }
    },
    deleteButtonDisabledStates() {
      // セクション情報取得
      const userId = localStorage.getItem("userId");
      const section = localStorage.getItem("section");
      // 利用者区分取得
      let userType = this.userTypeMapping[this.editUser.userType];
      if (this.editUser.userType === "行政機関") {
        userType = userType.concat(this.adminTypeMapping[this.editUser.adminType]);
      } else if (this.editUser.userType === "その他") {
        userType = userType.concat(this.otherTypeMapping[this.editUser.otherType]);
      }
      // 初期化
      this.disabledButton.delete = true;

      // 本人以外のデータは削除可能
      if (userId !== this.editUser.userId) {
        if (section === '0000') {
          // システム管理者
          // システム管理者は本人以外のデータはすべて削除可能
          this.disabledButton.delete = false;
        } else if (section === '0100') {
          // 行政機関・行政機関管理者
          if (userType != '0000') {
            // システム管理者以外のデータはすべて削除可能
            this.disabledButton.delete = false;
          }
        } else if (section === '0210') {
          // その他・見える化管理者
          if (userType === '0210' || userType === '0211') {
            // 見える化管理者、見える化メンバーのデータは削除可能
            this.disabledButton.delete = false;
          }
        }
      }
    },
    searchButtonDisabledStates() {
      // セクション情報取得
      const section = localStorage.getItem("section");
      if (section === '0000' || section === '0100' || section === '0210') {
        // 管理者は検索可
        this.disabledButton.search = false;
      } else {
        // 管理者以外は検索不可
        this.disabledButton.search = true;
      }
    },
    organizationDisabledStates() {
      // セクション情報取得
      const section = localStorage.getItem("section");
      if (section === '0000' || section === '0100' || section === '0210') {
        // 管理者は編集可
        this.disabledOrganization.affiliation = true;
      } else {
        // 管理者以外は編集不可
        this.disabledOrganization.affiliation = false;
      }
    },
    async updateeditUser() {
      const fieldsToValidate = [
        { field: "region", label: "地域", value: this.editUser.region, isRequired: true },
        { field: "userId", label: "利用者ID", value: this.editUser.userId, isRequired: true, maxLength: 8 },
        { field: "password", label: "パスワード", value: this.editUser.password, maxLength: 40 },
        { field: "passwordConfirm", label: "パスワード(確認用)", value: this.editUser.passwordConfirm, maxLength: 40 },
        { field: "userType", label: "利用者区分", value: this.editUser.userType, isRequired: true },
        { field: "email", label: "メールアドレス", value: this.editUser.email, isRequired: false, maxLength: 50 },
        { field: "fullNameKanji", label: "利用者氏名（漢字）", value: this.editUser.fullNameKanji, isRequired: true, maxLength: 50 },
        { field: "fullNameKana", label: "利用者氏名（カナ）", value: this.editUser.fullNameKana, isRequired: false, maxLength: 50 },
        { field: "zip", label: "郵便番号", value: this.editUser.zip, isRequired: false, maxLength: 8 },
        { field: "address1", label: "住所１（市町村まで）", value: this.editUser.address1, isRequired: false, maxLength: 20 },
        { field: "address2", label: "住所２", value: this.editUser.address2, isRequired: false, maxLength: 20 },
        { field: "birthday.type", label: "年号", value: this.editUser.birthday.type, isRequired: false },
        { field: "birthday", label: "生年月日", value: `${this.editUser.birthday.year}-${this.editUser.birthday.month}-${this.editUser.birthday.day}`, isRequired: false },
        { field: "birthday.year", label: "年", value: this.editUser.birthday.year, isRequired: false, maxLength: 4 },
        { field: "birthday.month", label: "月", value: this.editUser.birthday.month, isRequired: false, maxLength: 2 },
        { field: "birthday.day", label: "日", value: this.editUser.birthday.day, isRequired: false, maxLength: 2 },
        { field: "sex", label: "性別", value: this.editUser.sex, isRequired: false },
        { field: "homePhone", label: "固定電話番号", value: this.editUser.homePhone, isRequired: false, maxLength: 11 },
        { field: "mobilePhone", label: "スマートフォン番号", value: this.editUser.mobilePhone, isRequired: false, maxLength: 11 },
        { field: "department", label: "所在部署名称", value: this.editUser.department, isRequired: true, maxLength: 20 },
        { field: "notes", label: "備考", value: this.editUser.notes, isRequired: false, maxLength: 200 },
        { field: "directAdminOrg", label: "直属行政機関", value: this.editUser.directAdminOrg, isRequired: false },
        { field: "org_right", label: "所属行政機関", value: this.org_right, isRequired: false }
      ]

      // エラーモードを有効化し、バリデーション実行
      this.isErrorMode = true;
      this.errors = this.validateForm(fieldsToValidate);
      // エラーチェック
      if (Object.values(this.errors).every((error) => !error)) {
        const token = localStorage.getItem("jwtToken");
        const userId = localStorage.getItem("userId");

        // 利用者区分の設定
        /**
         * 利用者区分について、旧スマートHOKAKUを参考にする
         * あとからDB毎見直してもよさそうだが、ひとまずはこの仕組みで考える
         * 最終的にはスマートHOKAKUに統合する必要があるので一時仕様
         * 末尾が0は管理者
         * 
         * 0000：システム管理者
         * 0100：行政機関・行政機関管理者
         * 0101：行政機関・行政機関メンバー
         * 0210：その他・見える化管理者
         * 0211：その他・見える化メンバー
         * 0201：その他・捕獲者
         */
        let userTypeValue = this.userTypeMapping[this.editUser.userType];
        if (this.editUser.userType === "行政機関") {
          userTypeValue = userTypeValue.concat(this.adminTypeMapping[this.editUser.adminType]);
        } else if (this.editUser.userType === "その他") {
          userTypeValue = userTypeValue.concat(this.otherTypeMapping[this.editUser.otherType]);
        }

        try {
          // サーバーに送信するデータ
          const requestData = {
            region_id: this.editUser.region,
            id: this.editUser.userId,
            password: this.editUser.password,
            section: userTypeValue,
            nameKana: this.editUser.fullNameKana,
            nameKanji: this.editUser.fullNameKanji,
            zip: this.editUser.zip,
            zyuusho1: this.editUser.address1,
            zyuusho2: this.editUser.address2,
            birth: this.editUser.birthday.year + '/' + this.editUser.birthday.month + '/' + this.editUser.birthday.day,
            sex: this.editUser.sex === '不明' ? '0' :
                 this.editUser.sex === '男性' ? '1' :
                 this.editUser.sex === '女性' ? '2' : null,
            tell: this.editUser.homePhone,
            mail: this.editUser.email,
            mobile: this.editUser.mobilePhone,
            departName: this.editUser.department,
            directAdminAgency: this.editUser.directAdminOrg,
            affiliationAdminAgency: this.org_right || '',
            addNote: this.editUser.notes,
            modifierId: userId,
          };
          const response = await axios.post(
            `${process.env.VUE_APP_API_BASE_URL}/api/userRegister/update`,
            requestData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          // ステータスコード200の場合（送信成功）
          if (response.status === 200) {
            // 新しいトークンがレスポンスヘッダーに含まれている場合
            const newToken = response.headers.get('Authorization');
            if (newToken) {
                localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
            }
            // console.log("送信成功", response.data);
            alert("データが正常に更新されました");
          } else {
            alert("不明なエラーです");
		  }
          this.$router.go(0);
        } catch (error) {
			this.timeout();
        }
      } else {
        alert("入力エラーがあります");
      }
    },
    async deleteeditUser() {
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId");

      const confirmDelete = confirm("本当に削除しますか");
      if (!confirmDelete) {
          return Promise.resolve(); // キャンセルされた場合は何もしない
      }

      try {
        // リクエストボディに id を含める
        const requestData = { id: userId, deleteId: this.editUser.userId ,deleteFlg: '1' };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/userRegister/delete`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          alert(`削除が完了しました`);

          this.$router.go(0);
        } else {
		  alert("不明なエラーです");
        }
      } catch (error) {
		 this.timeout();
      }
    },
    async restoreEditUser() {
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId");

      const confirmDelete = confirm("復元しますか");
      if (!confirmDelete) {
          return Promise.resolve(); // キャンセルされた場合は何もしない
      }

      try {
        // リクエストボディに id を含める
        const requestData = { id: userId, deleteId: this.editUser.userId ,deleteFlg: '0' };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/userRegister/delete`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          alert(`復元が完了しました`);

          this.$router.go(0);
        } else {
		  alert("不明なエラーです");
        }
      } catch (error) {
		 this.timeout();
      }
    },
    getUserDetails(result) {
	// 意味不明
	//this.user_id = result.id;
	//this.selectedResult = result;
	//this.removeAllAffiliatedOrgs();
	this.editUser.userId = result.id;
	this.editUser.region = result.region_id;

          const date = new Date(result.birth);
          // editUser の設定
          this.editUser = {
			...this.editUser,	// 意味不明だが・・・
            deleteFlg: result.deleteFlg,
            region: result.region_id,
            userId: result.id,
			fullNameKanji: result.nameKanji,
			fullNameKana: result.nameKana,
            password: "",
            passwordConfirm: "",
            userType:
              result.section.slice(0, 2) === "00" ? "システム管理者" :
              result.section.slice(0, 2) === "01" ? "行政機関" :
              result.section.slice(0, 2) === "02" ? "その他" : null,
            adminType: result.section === "0100" ? "行政機関管理者" :
              result.section === "0101" ? "行政機関メンバー" : null,
            otherType: result.section === "0210" ? "見える化管理者" :
              result.section === "0211" ? "見える化メンバー" :
              result.section === "0201" ? "捕獲者" : null,
            email: result.mail,
            zip: result.zip,
            address1: result.zyuusho1,
            address2: result.zyuusho2,
            birthday: { 
              type: "西暦", 
              year: date.getFullYear(), 
              month: String(date.getMonth() + 1).padStart(2, "0"), 
              day: String(date.getDate()).padStart(2, "0") 
            },
            sex: result.sex === "0" ? "不明" :
                result.sex === "1" ? "男性" :
                result.sex === "2" ? "女性" : null,
            homePhone: result.tell,
            mobilePhone: result.mobile,
            department: result.departName,
            notes: result.addNote,
            directAdminOrg: result.directAdminAgency,
          };

          // this.org_right = result.affiliationAdminAgency || [];
		  this.org_right = [];
		  this.org_left = this.selectedAdminOrgs;
		  //this.org_left = this.groups;
		  if (result.affiliationAdminAgency) {
		  result.affiliationAdminAgency.forEach((id) => {
        	const org = this.org_left.find((o) => o.gyouseiId == id);
        	if (org && !this.org_right.includes(org)) {
          		this.org_right.push(org);
          		this.org_left = this.org_left.filter(
					(o) => o.gyouseiId != id);
        	}
		  });
		  }
          if (this.editUser.deleteFlg === '1') {
            this.isDisabled = true;
          }
	  	  this.btnoff = false;
    },

    async getRegionDetails() {
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId"); // ローカルストレージから userId を取得
      const section = localStorage.getItem("section");
      const regionId = localStorage.getItem("regionId");

      try {
        // リクエストボディに id を含める
        const requestData = { id: userId };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/regionSearch/getList`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          if (section === '0000') {
            this.regions = response.data.data;
            // console.log("管理者なので全地域設定");
          } else {
            this.regions = response.data.data.filter(org => org.region_id === regionId);
            // console.log("管理者以外はフィルタした情報を設定");
          }
        } else {
		  	alert("不明なエラーです");
			return true;
        }
      } catch (error) {
		this.timeout();
		return true;
      }
	  return false;
    },

    openModal() {
      this.searchData = { keyword: '' }
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    async handleSelect(result) {
      // イベントオブジェクトかどうかを判定
      if (result && result.target) {
        return;
      }
	  // 都道府県のみ同期させる
	  this.region_id = result.region_id;
      //this.getUserDetails(result);
	  this.group_id = result.directAdminAgency;
	  this.user_id = result.id;
	  //this.btnoff = false;
      this.getUserDetails(result);
    },
  },
};
</script>

<style scoped>
.disabled-table {
  pointer-events: none; /* クリック・入力を無効化 */
  opacity: 0.5; /* 視覚的に非活性化 */
}

.button-group {
  display: flex;
  justify-content: center; /* ボタンを中央に配置 */
  margin-top: 10px; /* 上部の余白 */
}

.checkbox-group {
  display: flex; /* 横並びにする */
  gap: 10px; /* 各要素の間隔 */
}

.button-column-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.button-column-container button {
  background-color: #4caf50;
  color: white;
  border: none;
}

.button-column-container button:hover {
  background-color: #45a049; /* ホバー時に背景色を濃くする */
  transition: background-color 0.3s ease; /* なめらかな変化を追加 */
}
.abc { padding: 1em; }
.usual { background-color: #17a2b8; }
.first { background-color: #28a745; }
.alert { background-color: #ff6347; }
.second { background-color: #6c757d; }
</style>
